(function () {
  function initCarousel(root) {
    if (!root || root.dataset.sunnierVideosInit === "true") return;
    root.dataset.sunnierVideosInit = "true";

    const track = root.querySelector("[data-sunnier-video-track]");
    const prev = root.querySelector("[data-sunnier-video-prev]");
    const next = root.querySelector("[data-sunnier-video-next]");
    const items = Array.from(root.querySelectorAll("[data-sunnier-video-item]"));
    if (!track || !items.length) return;

    function scrollByCard(direction) {
      const card = items[0];
      const gap = parseFloat(getComputedStyle(track).gap || "16");
      const amount = card.getBoundingClientRect().width + gap;
      track.scrollBy({ left: direction * amount, behavior: "smooth" });
    }

    if (prev) prev.addEventListener("click", () => scrollByCard(-1));
    if (next) next.addEventListener("click", () => scrollByCard(1));

    function updateArrows() {
      if (!prev || !next) return;
      const max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }

    track.addEventListener("scroll", updateArrows, { passive: true });
    window.addEventListener("resize", updateArrows);
    updateArrows();

    const videos = Array.from(root.querySelectorAll("video[data-src]"));

    function activateVideo(video) {
      if (video.dataset.loaded === "true") {
        video.play().catch(() => {});
        return;
      }
      const src = video.dataset.src;
      if (!src) return;
      const source = document.createElement("source");
      source.src = src;
      source.type = video.dataset.type || "video/mp4";
      video.appendChild(source);
      video.dataset.loaded = "true";
      video.removeAttribute("controls");
      video.controls = false;
      video.muted = true;
      video.playsInline = true;
      video.loop = true;
      video.setAttribute("disablepictureinpicture", "");
      video.setAttribute("disableremoteplayback", "");
      video.load();
      video.play().catch(() => {});
    }

    function pauseVideo(video) {
      if (!video.paused) video.pause();
    }

    const itemObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target.querySelector("video[data-src]");
          if (!video) return;
          if (entry.isIntersecting && entry.intersectionRatio >= 0.45) {
            activateVideo(video);
          } else {
            pauseVideo(video);
          }
        });
      },
      { root: track, threshold: [0, 0.45, 0.75] }
    );

    items.forEach((item) => itemObserver.observe(item));

    // Also wake the whole section when it enters the viewport
    const sectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          items.forEach((item) => {
            const rect = item.getBoundingClientRect();
            const trackRect = track.getBoundingClientRect();
            const visible =
              rect.left < trackRect.right - 40 && rect.right > trackRect.left + 40;
            const video = item.querySelector("video[data-src]");
            if (visible && video) activateVideo(video);
          });
        });
      },
      { threshold: 0.2 }
    );
    sectionObserver.observe(root);
  }

  function boot() {
    document
      .querySelectorAll("[data-sunnier-video-carousel]")
      .forEach(initCarousel);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
  document.addEventListener("shopify:section:load", boot);
})();
